<template>
    <!--更换部门-->
    <div class="panel">
        <div class="head">
            <span class="title">更换部门</span>
        </div>

        <Form :label-width="100">
            <FormItem label="所属部门">
                <Select v-model="gid" :style="{width:'300px',marginRight:'80px'}">
                    <Option v-for="item in groupList" :value="item.id" :key="item.id">{{ item.name }}</Option>
                </Select>
                <Button type="primary" @click="setGroup">确认</Button>
            </FormItem>
        </Form>

        <Modal v-model="warning.status" :loading="loading2" :title="warning.title" @on-ok="doSetGroup" :mask-closable="false">
            {{warning.tip}}
        </Modal>
    </div>
</template>

<script>
    import $api from "@/service/index";
    import utils from "@/utils";

    export default {
        props:{
            uid:String,
            groupId:String,
            username:String,
        },
        data(){
            return {
                loading2 : false,
                //所属部门备选项
                groupList : [],
                gid : "0",
                warning : {
                    status : false,
                    title : "更换部门",
                    tip : "确定更换部门吗？",
                },
            }
        },
        created(){
            this.gid = this.groupId;
            this.getGroupList();
        },
        methods:{
            //手动初始化gid
            setGid(id){
                this.gid = id;
            },
            //获取当前单位所有部门
            getGroupList(){
                let _self = this;
                $api.getCompanyUserGroup("group").then(data => {
                    _self.groupList = data;
                    _self.gid = _self.groupId;
                });
            },
            setGroup(){
                if(this.gid === "0" || !this.gid || this.gid === 0){
                    utils.notice("请选择所属部门","error");
                    return false;
                }
                let _self = this;
                let groupName = "新部门";
                for(let i=0;i<=this.groupList.length;i++){
                    if(this.groupList[i].id === this.gid){
                        groupName = this.groupList[i].name;
                        break;
                    }
                }
                this.warning = {
                    status : true,
                    title : "更换部门",
                    tip : "确定将"+_self.username+"移动到"+groupName+"？",
                };
            },
            //修改部门
            doSetGroup(){
                this.loading2 = true;
                let _self = this;
                $api.setUserGroup(_self.uid,_self.gid).then(data=>{
                    _self.loading2 = false;
                    // utils.notice("更换成功","success");
                    utils.message({title: "更换成功"}, 'success');
                    this.$emit("refresh");
                });
            },
        },
    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/pages/company/member/business/EditUserGroup.vue